export const DAYS = [1, 3, 7, 14, 30]
export const MAX = Math.max(...DAYS)

export default DAYS[2]
